import { LexicalNode } from '@eastcoal/editor/exports'

import {
  $isTableVariableNode,
  TableVariableNode
} from '../editor/nodes/TableVariableNode'
import {
  $isTextVariableNode,
  TextVariableNode
} from '../editor/nodes/TextVariableNode'

export type TemplateVariableNode = TableVariableNode | TextVariableNode

export const $isTemplateVariableNode = (
  node: LexicalNode | null
): node is TemplateVariableNode => {
  return $isTableVariableNode(node) || $isTextVariableNode(node)
}
